import React, { useState } from 'react'
import Modal from '../../../modal'
import Button from '../../../button'
import styled from 'styled-components'
import { useMutation } from '@apollo/react-hooks'
import LoadingButton from '../../../loading-button'
import useTargetDocumentBucketOptions from './useTargetDocumentBucketOptions'
import Autocomplete from './autocomplete'
import Divider from '../../../divider'
import MoveIcon from '../icons/move'
import MoveDocFile from '../../../../queries/MoveDocFile'
import { useSnackbar } from '../../../../contexts/SnackbarContext'

const ButtonsContainerElement = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`

const FilenameElement = styled.p`
  font-size: 1rem !important;
  font-weight: 200 !important;
  margin: 0;
`

const SubtitleContainerElement = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 1.5rem 0;
`

const ContentWrapperElement = styled.form`
  width: 45rem;
  margin: 0 !important;
`

const AutocompleteWrapper = styled.div`
  margin: 1.5rem 0;
  width: 75%;
`

const SubtitleElement = styled.h4`
  font-size: 1rem !important;
  font-weight: 200 !important;
  margin: 0 !important;
  margin-bottom: 0.5rem !important;
`

function MoveFileModal({ file, onClose, documentId }) {
  const { setSuccessMessage, setErrorMessage } = useSnackbar()
  const [targetDocumentId, setTargetDocumentId] = useState(null)

  const targetOptions = useTargetDocumentBucketOptions({
    originDocumentId: documentId,
  })

  const [moveDocFileMutation, { loading }] = useMutation(MoveDocFile, {
    variables: {
      input: {
        ogDocumentId: documentId,
        targetDocumentId: targetDocumentId,
        fileUuid: file.uuid,
      },
    },
    onCompleted: () => {
      setSuccessMessage('Document moved successfully')
      onClose()
    },
    onError: () => setErrorMessage('There was an error moving the document'),
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    moveDocFileMutation()
  }

  const handleClose = () => !loading && onClose()

  return (
    <Modal
      title="Move document to another bucket"
      onClose={handleClose}
      overflowY="visible"
    >
      <ContentWrapperElement onSubmit={handleSubmit}>
        <SubtitleContainerElement>
          <MoveIcon />
          <FilenameElement>{file.trimmedFilename}</FilenameElement>
        </SubtitleContainerElement>
        <Divider />
        <AutocompleteWrapper>
          <SubtitleElement>Document bucket</SubtitleElement>
          <Autocomplete
            options={targetOptions}
            selectedOptionId={targetDocumentId}
            setSelectedOptionId={setTargetDocumentId}
          />
        </AutocompleteWrapper>
        <ButtonsContainerElement>
          <Button color="gray" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            disabled={!targetDocumentId || loading}
            isLoading={loading}
            width="5rem"
            type="submit"
          >
            Move
          </LoadingButton>
        </ButtonsContainerElement>
      </ContentWrapperElement>
    </Modal>
  )
}

export default MoveFileModal
